// A stale, pending, or failed Core search must never be treated as no matches.
export function supplierAsiSearchMode({ query, coreLookup, manualAsiQuery, searchReady = true }) {
  const term = String(query || "").trim();
  if (!searchReady || term.length < 2
    || coreLookup?.query !== term || coreLookup?.status !== "success") {
    return "inactive";
  }
  if (!coreLookup.hasMatches || manualAsiQuery === term) return "search";
  return "offer";
}
